import React from 'react';
import './footer.styles.css'

const Footer = () => (
    <div className="footer">
        <p>Made with <span>💛</span> by <a href="https://github.com/Hina-softwareEngineer">HINA KHADIM</a></p>
    </div>
);


export default Footer;